import React from 'react';
import styled from 'styled-components';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';

const Banner = styled(Box).attrs({
  align: 'center',
  px: 20,
  py: 12,
  bg: 'lightDanger',
  color: 'background',
  horizontal: true,
  borderRadius: 5,
  m: '0 auto',
  width: '92%',
})``;

/**
 * Currently only for CSP users. Displays a danger banner indicating there is no ADR
 * but it can still be dispatched
 */
const NoTrainADRBanner = () => {
  return (
    <Banner data-testid="NoTrainADRBanner">
      <AttentionTriangleIcon width={16} height={16} />
      <Text ml={12} size="normal">
        Location data only. Requesting dispatch will only share location.
      </Text>
    </Banner>
  );
};

export default NoTrainADRBanner;
